import FrontHeaderLayout from '@/Layouts/FrontHeaderLayout';
import Button from '@/components/atoms/button';
import Heading from '@/components/atoms/heading';
import Text from '@/components/atoms/text';
import ActionFooter from '@/components/molecules/actionFooter';
import FormItem from '@/components/molecules/formItem';
import Alert from '@/components/molecules/alert';
import { useForm, usePage } from '@inertiajs/react';
import { useState } from 'react';
import { useEffect } from 'react';

export default function BrokerSearchForm({ data, errors, setData }) {
	const { policyName } = usePage().props;

	const [brokerData, setBrokerData] = useState([]);
	const [selectedBroker, setSelectedBroker] = useState(null);
	const [brokerList, setBrokerList] = useState({});
	const [hasSearched, setHasSearched] = useState(false);

	useEffect(() => {
		if (selectedBroker) {
			setData('broker_id', selectedBroker.id);
		}
	}, [selectedBroker]);

	const checkForBroker = async (e) => {
		e.preventDefault();
		if(!data.broker_postcode) return;

		const response = await axios.get('/api/admin/check-for-broker-duplicates', {
			params: {
				postcode: data.broker_postcode,
			},
		});
		setHasSearched(true);
		if (response.data) {
			console.log('response.data.duplicates', response.data.duplicates);
			setBrokerData(response.data.duplicates);
			if (response.data.duplicates.length === 1) {
				setSelectedBroker(response.data.duplicates[0]);
			} else if (response.data && response.data.duplicates.length > 1) {
				let list = [];
				response.data.duplicates.forEach((broker) => {
					const ad = [
						broker.address_1,
						broker.town,
						broker.county,
						broker.postcode,
					].filter((x) => x);
					list.push({ label: `${broker.name}, ${ad}`, value: broker.id });
				});
				setBrokerList(list);
			}
		}
	};

	return (
		<div className="flex flex-col items-start gap-8 md:flex-row">
			<div className="flex flex-col gap-2 md:gap-6 shrink-0 md:basis-[26.466%]">
				<Heading className="text-eis-black" type="h4">
					Broker Details
				</Heading>
				<Text type="p" variant="normal" className="text-formOutlineDark">
					Fields marked * are required to submit form
				</Text>
			</div>
			<div className="w-full space-y-8">
				<div className="flex flex-row items-end w-full gap-2">
					<FormItem
						type="text"
						name="broker_postcode"
						label="Postcode"
						placeholder="Postcode"
						value={data.broker_postcode}
						onChange={(value) => setData('broker_postcode', value)}
						autoComplete="Postcode"
						validation="required"
						meta={{
							msg: errors?.broker_postcode || errors?.broker_id,
							touched: errors?.broker_postcode || errors?.broker_id ? true : false,
						}}
						className="grow"
					/>

					<Button variant="primary" onClick={checkForBroker}>
						Find Broker
					</Button>
				</div>

				{hasSearched && brokerList && brokerList.length > 1 && (
					<div className="flex flex-col gap-4">
						<Text type="p" variant="normal" className="text-black">
							We found multiple brokers with the same postcode, please select the correct one below:
						</Text>
						<FormItem
							type="select"
							label="Select a broker"
							name="broker_id"
							placeholder="Please select your brokerage"
							options={brokerList}
							onChange={(value) => {
								if (!value) return;
								setSelectedBroker(brokerData.find((broker) => broker.id === parseInt(value)));
							}}
							meta={{
								msg: errors.broker_id,
								touched: errors.broker_id ? true : false,
							}}
						/>
					</div>
				)}

				{hasSearched && selectedBroker && (
					<>
						<div className="flex flex-col">
							<Text type="p" variant="bold" className="text-black">
								{selectedBroker.name}
							</Text>
							<Text type="p" variant="normal" className="text-black">
								{selectedBroker.address_1}
							</Text>
							<Text type="p" variant="normal" className="text-black">
								{selectedBroker.town}
							</Text>
							{selectedBroker.county && (
								<Text type="p" variant="normal" className="text-black">
									{selectedBroker.county}
								</Text>
							)}
							<Text type="p" variant="normal" className="text-black">
								{selectedBroker.postcode}
							</Text>
						</div>

						{selectedBroker.status && selectedBroker.status !== 'active' && (
							<Alert
								type="warning"
								title="Please note"
								description="Before we can confirm you application, we will need to speak with you as there appears to be an error on your broker account, please continue to complete the rest of the form and one of the team will get in touch, alternatively please contact us on 01425 470 360 once the form has been completed."
							/>
						)}
					</>
				)}

				<FormItem
					type="text"
					name="broker_name"
					label="Contact Name"
					placeholder="Contact Name"
					value={data.contact_name}
					onChange={(value) => setData('broker_name', value)}
					autoComplete="contact_name"
					validation="required"
					meta={{
						msg: errors?.broker_name,
						touched: errors?.broker_name ? true : false,
					}}
				/>

				<FormItem
					type="text"
					name="broker_phone"
					label="Daytime telephone number (without spaces)"
					placeholder="Daytime telephone number (without spaces)"
					value={data.broker_phone}
					onChange={(value) => setData('broker_phone', value)}
					autoComplete="phone"
					validation="required"
					meta={{
						msg: errors?.broker_phone,
						touched: errors?.broker_phone ? true : false,
					}}
				/>

				<FormItem
					type="email"
					name="broker_email"
					label="Email address"
					placeholder="Email address"
					value={data.broker_email}
					onChange={(value) => setData('broker_email', value)}
					autoComplete="email"
					validation="required"
					meta={{
						msg: errors?.broker_email,
						touched: errors?.broker_email ? true : false,
					}}
				/>
			</div>
		</div>
	);
}
